import {includes, createSelector} from 'helpers';
import {categories} from './categories';
import {createdDate, createdDateNegative} from 'store/common';

export const settings = createSelector(
  [ categories, state => state.settings.notes ],
  ( categories, settings = {} ) => ({
    //default settings
    sort: 'newest',
    blacklist: [],
    //current settings
    ...settings,
    categories,
  })
);

export const isBlacklisted = createSelector(
  ( settings ),
  ({ blacklist }) => ({ categoryId, category }) => includes(blacklist, categoryId || category),
);

export const sort = createSelector(
  ( settings ),
  ({ sort }) => {
    const result = sort == 'oldest' ? [ 'date', createdDate ] : [ note => -1*note.date, createdDateNegative ];
    result.name = sort;
    return result;
  }
);
